import { render, staticRenderFns } from "./WritePostcard.vue?vue&type=template&id=5ca688a4&"
import script from "./WritePostcard.vue?vue&type=script&lang=js&"
export * from "./WritePostcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports